import React, { useContext, useEffect, createContext } from 'react';

// project-imports
import { showToast } from '../components/sweet-alert/Sweetalert';
import { getInstructor } from './salesforce_api_context';
import { GET_INSTRUCTOR_BEGIN, GET_INSTRUCTOR_SUCCESS, GET_INSTRUCTOR_FAILURE } from '../constants/actions';
import instructorData1 from '../data/instructor/InstructorData.json';
import { useBugContext } from './bug_context';

// third-party
import { useDispatch, useSelector } from "react-redux";

// Create context
export const InstructorContext = createContext();

export const InstructorProvider = (props) => {

    // Reading dispatch from Store
    const dispatch = useDispatch();

    // Constant variable
    const instructorData = useSelector(state => state.instructor);

    const { bugReportApi } = useBugContext();

    // Constant function

    // Function to get the instructor details
    const fetchInstructors = async () => {
        try {

            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_INSTRUCTOR_BEGIN, payload: true });


            // Calling API to get instructor
            let response = await getInstructor();
            // let response = instructorData1;

            // Dispatching the actions on success
            dispatch({ type: GET_INSTRUCTOR_SUCCESS, payload: response });

            // Showing the toast message on getting instructor data successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("46 : instructor_context : Error while getting instructor::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_INSTRUCTOR_FAILURE, payload: error && error.message });

            bugReportApi("Error while fetching instructor", `/services/apexrest/instructordata/?collectionId=instructordata`, "GET", error);

            // Showing the toast message on getting instructor unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the instructor!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }
    useEffect(() => {
        fetchInstructors();
    }, []);

    return (
        <InstructorContext.Provider value={{ ...instructorData, fetchInstructors }}>
            {props.children}
        </InstructorContext.Provider>
    )
}
export const useInstructorContext = () => {
    return useContext(InstructorContext)
}
